module.exports = __webpack_public_path__ + "static/media/okaygoIcon.9049e646.svg";